import moment from "moment";

export const ValueUtils = {

    getStringOrDefault(value, orDefault) {
        return value ?? orDefault
    },

    getMomentOrNull(value) {
        return value ? moment(Number(value)) : null
    },

    formatDateOrEmpty(value, format = 'YYYY-MM-DD') {
        return value ? moment(Number(value)).format(format) : null
    },
}